@use "src/theme";

.item {
  position: relative;
  justify-content: flex-start;
  display: flex;
  text-align: start;
  width: 100%;
  min-height: 2.5rem;
  gap: 0.75rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  border-radius: var(--radius-md);

  .selectedIcon {
    display: none;
  }

  &:focus {
    z-index: 1;
  }

  &:focus-visible {
    @include theme.focus-ring-inset;
  }

  &:hover,
  &[data-highlighted] {
    color: var(--color-foreground);
    background: var(--color-card-hover);
  }

  // Disabled items are muted, not faded.
  &:disabled,
  &[data-disabled] {
    color: var(--color-muted-foreground);
    pointer-events: none;

    svg {
      color: var(--color-muted-foreground);
    }
  }

  &[data-selected="true"] {
    color: var(--color-foreground);
    background: var(--color-primary-soft);
  }

  &[data-color="danger"] {
    color: var(--color-danger-text);

    &:hover,
    &[data-highlighted] {
      color: var(--color-danger-text);
    }
  }

  &[data-state="checked"],
  &[data-selected="true"] {
    .selectedIcon {
      margin-inline-start: 0.5rem;
      display: block;
    }
  }
}

.menu {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.label {
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
